<template>
	<sf-data-table
		ref="table"
		:columns="columns"
		:rows="rows"
		selection
		:height="height"
		@changedPage="onChangePage"
		v-bind="masterPagingInfo"
		rowKey="rnum"
		:pageUnit="masterPagingInfo.pageUnit"
		:pageArray="screen.pageArray"
		:totalSize="masterPagingInfo.totalSize"
	>
		<template v-slot:actionsLeft>
			<!-- 저장 -->
			<sf-button line v-if="isButton_(scrId, 'CU')" icon="file" :onClick="saveDtlPopupAction">{{ getMessage_('MWCC000138') }}</sf-button>
			<!-- <sf-button line v-if="isButton_(scrId, 'AD')" icon="square-plue" :onClick="addRow">{{ getButtonMsg_(scrId, 'AD') }}</sf-button>
			<sf-button line v-if="isButton_(scrId, 'CU')" icon="file" :onClick="saveAction">{{ getMessage_('MWCC000138') }}</sf-button>
			<sf-button line v-if="isButton_(scrId, 'CU')" icon="square-plue" :onClick="copyPopup">{{ getMessage_('QWCC001098') }}</sf-button> -->
			<!-- 항목복사 -->
			<!-- <sf-button line v-if="isButton_(scrId, 'CD')" icon="trash" color="error" :onClick="() => onClickButton('delete')">{{
				getButtonMsg_(scrId, 'CD')
			}}</sf-button> -->
		</template>
	</sf-data-table>
</template>

<script>
import { serviceComputed, serviceMethods } from '@qms/pqy/pcku/PartCkuPrvs/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
export default {
	props: {
		scrId: { type: String, default: '' },
		height: { type: String, default: '100%' }
	},
	created() {
		// console.log('master Popup create수행');
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.detailPopupList;
		},
		columns() {
			return [
				// { label: 'No.', prop: 'rnum', width: '60px' },
				// { label: this.getMessage_('MWCC000141'), prop: 'status', width: '90px' },
				// { label: 'partNo', prop: 'partNo', width: '60px' },
				{
					//사용여부
					label: this.getMessage_('MWCC000145'),
					prop: 'useYn',
					width: '90px',
					form: {
						type: 'select',
						options: this.getUseYnList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					// 검사항목
					label: this.getMessage_('QWCC001058'),
					prop: 'ckuPrvsCd',
					width: '100px',
					form: {
						type: 'select',
						options: this.getCkuPrvsList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					// 항목분류
					label: this.getMessage_('QWCC001059'),
					prop: 'prvsClCd',
					width: '100px',
					form: {
						type: 'input',
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					// 항목분류명
					label: this.getMessage_('QWCC001060'),
					prop: 'prvsClNm',
					width: '120px',
					form: {
						type: 'input',
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					// 검사방법
					label: this.getMessage_('QWCC001062'),
					prop: 'ckuWayCd',
					width: '100px',
					form: {
						type: 'select',
						options: this.getCkuWayList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					// 규격하한
					label: this.getMessage_('QWCC001204'),
					prop: 'nrmLlmtVal',
					width: '80px',
					form: {
						maxLength: 9,
						type: 'number',
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					// 규격상한
					label: this.getMessage_('QWCC001205'),
					prop: 'nrmUplmVal',
					width: '80px',
					form: {
						maxLength: 5,
						type: 'number',
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					// 스펙
					label: this.getMessage_('QWCC001884'),
					prop: 'spcRslt',
					width: '120px',
					form: {
						type: 'input',
						maxLength: 20,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					// 단위
					label: this.getMessage_('RCMS000090'),
					prop: 'utmCd',
					width: '90px',
					form: {
						type: 'select',
						options: this.getUtmList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					//추가여부
					label: 'ADD',
					prop: 'addYn',
					width: '1px',
					form: {
						type: 'input',
						isDisabled: ({}) => true // 에디트 방지
					}
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onChangePage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				return; //초기 중복 조회 방지.
			}
			this.$sf_toggleLoading(true);
			this.searchCommCdType_({ currentPage: currentPageVal, pageUnit: pageUnitVal }).finally(() => this.$sf_toggleLoading(false));
		},
		getDtlSelectedRows() {
			return this.$refs.table.getSelectedRows();
		},
		getDtlClearSelection() {
			console.log('클리어 진행');
			this.$refs.table.clearSelection();
		},
		saveDtlPopupAction() {
			//체크박스로 선택된 행이 있는지 확인
			const selected = this.$refs.table.getSelectedRows();
			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			// 컨펌창 실행
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				title: this.getMessage_('MWCC000501'), //저장하시겠습니까?
				buttons: [{ title: this.getMessage_('MWCC000103'), clickFn: this.save }] //저장
			});
		},
		async save() {
			this.$sf_toggleLoading(true);
			try {
				// 유효성 검사
				// for (let i = 0; i < this.getUpdatedRows_.length; i++) {
				// 	this.schema.validateSync(this.getUpdatedRows_[i]);
				// }
				const saveRows = this.$refs.table.getSelectedRows();
				//const partNo = this.searchParams.partNo;
				const params = { partNo: this.searchPopupDParams.partNo, saveRows: saveRows };
				const { code, messageCd } = await this.savePopupList_(params);
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
				}
				// this.resetTable();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	}
};
</script>

<style></style>
